export enum BatchMarkingType {
  BestBefore = 1,
  UseBy = 2
}

(BatchMarkingType as any).__typeName = 'BatchMarkingType';
